globalThis.$ = $
globalThis.jQuery = $

export { default } from './TabeebSidebar'
